import { useEffect, useState } from "react";
import OrderApi from "../../Api/OrderApi";
import { Order } from "../../Models/Order";
import Loader from "../Common/Loader";
import { toast } from "react-toastify";
import { Button, Select, TextInput } from "flowbite-react";
import { useAppDispatch, useAppSelector } from "../../Reducers/store";
import {
  ClientAddress,
  ClientAddressTypeEnum,
} from "../../Models/ClientAddress";
import ClientApi from "../../Api/ClientApi";
import { fetchCustomOptions, fetchStates } from "../../Actions/CommonFields";
import { useNavigate } from "react-router-dom";
import { CustomOptionsEnum } from "../../Models/CustomOptionsEnum";
import { formatPhoneNumber } from "../../Utils";

export default function OrderCheckout() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { userModel } = useAppSelector((state) => state.user);
  const { states, customOptions } = useAppSelector(
    (state) => state.commonFields
  );
  const [buttonDisabled, setButtonDisabled] = useState<boolean>(false);
  const [loading, setIsLoading] = useState<boolean>();
  const [orderData, setOrderData] = useState<Order>({
    id: 0,
    businessName: null,
    contactName: null,
    contactPhone: null,
    contactEmail: null,
    notes: null,
    dateCreated: null,
    orderStatusId: null,
    userId: null,
    billingAddressId: null,
    shippingAddressId: null,
    dateSubmitted: null,
    ponumber: null,
    clientId: userModel?.clientId ?? null,
    shippingMethodId: 15,

    client: null,
    orderItems: [],
    billingAddress: null,
    shippingAddress: null,
    user: null,
  });
  const [addressData, setaddressData] = useState<ClientAddress[] | null>(null);
  const [selectedBillingId, setselectedBillingId] = useState<number>(0);
  const [selectedShippingId, setselectedShippingId] = useState<number>(0);

  const [billingAddressData, setbillingAddressData] = useState<ClientAddress>({
    id: 0,
    typeId: null,
    clientId: userModel?.clientId ?? null,
    address1: null,
    address2: null,
    city: null,
    stateId: null,
    zip: null,
    country: null,
    isPrimary: null,

    state: null,
  });
  const [shippingAddressData, setshippingAddressData] = useState<ClientAddress>(
    {
      id: 0,
      typeId: null,
      clientId: userModel?.clientId ?? null,
      address1: null,
      address2: null,
      city: null,
      stateId: null,
      zip: null,
      country: null,
      isPrimary: null,

      state: null,
    }
  );

  const getReferences = async () => {
    if (!states.length || !customOptions.length) {
      await Promise.all([
        dispatch(fetchStates()),
        dispatch(fetchCustomOptions()),
      ]);
    }
  };

  const getOrder = () => {
    setIsLoading(true);
    const openOrderId =
      localStorage.getItem("openOrderId") &&
      Number(localStorage.getItem("openOrderId")) >= 0
        ? Number(localStorage.getItem("openOrderId"))
        : 0;
    OrderApi.getOrder(openOrderId)
      .then((res) => {
        if (res.data.id > 0) {
          setOrderData(res.data);
          if (!res.data.contactName) {
            setOrderData((prevData) => ({
              ...prevData,
              contactName: userModel?.firstName + " " + userModel?.lastName,
            }));
          }
          if (!res.data.contactPhone) {
            setOrderData((prevData) => ({
              ...prevData,
              contactPhone: formatPhoneNumber(userModel?.phoneNumber ?? ""),
            }));
          } else {
            setOrderData((prevData) => ({
              ...prevData,
              contactPhone: formatPhoneNumber(res.data.contactPhone ?? ""),
            }));
          }
          if (!res.data.contactEmail) {
            setOrderData((prevData) => ({
              ...prevData,
              contactEmail: userModel?.emailAddress ?? "",
            }));
          }
          if (!res.data.shippingMethodId) {
            setOrderData((prevData) => ({
              ...prevData,
              shippingMethodId: 15,
            }));
          }
          localStorage.setItem("openOrderId", res.data.id.toString());
        } else {
          //navigate away
        }
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };

  const getDefaultInformation = () => {
    //get clientaddresses
    if (userModel) {
      ClientApi.getClientAddresses(userModel.clientId ?? 0)
        .then((res) => {
          setaddressData(res.data);
          setIsLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setIsLoading(false);
        });
      //populate 2 drop downs based on typeid
      //populate address forms}
    }
  };

  useEffect(() => {
    if (addressData) {
      if (orderData.billingAddressId) {
        const billing = addressData.find(
          (x) => x.id === orderData.billingAddressId
        );
        if (billing) {
          setbillingAddressData(billing);
          setselectedBillingId(billing.id);
        }
      }

      if (orderData.shippingAddressId) {
        const shipping = addressData.find(
          (x) => x.id === orderData.shippingAddressId
        );
        if (shipping) {
          setshippingAddressData(shipping);
          setselectedShippingId(shipping.id);
        }
      }
    }
  }, [addressData, orderData.billingAddressId, orderData.shippingAddressId]);

  useEffect(() => {
    getReferences();
    getOrder();
    getDefaultInformation();
  }, []);

  const handleChangeInputContact = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    const formattedValue =
      name === "contactPhone" ? formatPhoneNumber(value) : value;

    setOrderData((prevData) => ({ ...prevData, [name]: formattedValue }));
  };
  const handleChangeSelectContact = (
    e: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setOrderData((prevData) => ({ ...prevData, [name]: value }));
  };
  const handleChangeInputBilling = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setbillingAddressData((prevData) => ({ ...prevData, [name]: value }));
    setselectedBillingId(0);
  };
  const handleChangeSelectBilling = (
    e: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setbillingAddressData((prevData) => ({ ...prevData, [name]: value }));
    setselectedBillingId(0);
  };

  const handleChangeInputShipping = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { name, value } = e.target;
    setshippingAddressData((prevData) => ({ ...prevData, [name]: value }));
    setselectedShippingId(0);
  };
  const handleChangeSelectShipping = (
    e: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setshippingAddressData((prevData) => ({ ...prevData, [name]: value }));
    setselectedShippingId(0);
  };

  const handleChangeBilling = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { value } = e.target;
    if (!value) {
      setselectedBillingId(0);
      setbillingAddressData({
        id: 0,
        typeId: null,
        clientId: userModel?.clientId ?? null,
        address1: null,
        address2: null,
        city: null,
        stateId: null,
        zip: null,
        country: null,
        isPrimary: null,
        state: null,
      });
    } else {
      const selectedBilling = addressData?.find((x) => x.id === Number(value));
      if (selectedBilling) {
        setbillingAddressData(selectedBilling);
        setselectedBillingId(Number(value));
      }
    }
  };

  const handleChangeShipping = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { value } = e.target;
    if (!value) {
      setselectedShippingId(0);
      setshippingAddressData({
        id: 0,
        typeId: null,
        clientId: userModel?.clientId ?? null,
        address1: null,
        address2: null,
        city: null,
        stateId: null,
        zip: null,
        country: null,
        isPrimary: null,
        state: null,
      });
    } else {
      const selectedShipping = addressData?.find((x) => x.id === Number(value));
      if (selectedShipping) {
        setshippingAddressData(selectedShipping);
        setselectedShippingId(Number(value));
      }
    }
  };

  const onSubmit = async (e: React.ChangeEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (
      selectedBillingId === 0 &&
      (!billingAddressData.address1 ||
        !billingAddressData.city ||
        !billingAddressData.zip)
    ) {
      toast.error("Please complete the Billing Address fields.");
      setButtonDisabled(false);
      return;
    }

    if (
      selectedShippingId === 0 &&
      (!shippingAddressData.address1 ||
        !shippingAddressData.city ||
        !shippingAddressData.zip)
    ) {
      toast.error("Please complete the Shipping Address fields.");
      setButtonDisabled(false);
      return;
    }

    setButtonDisabled(true);
    let billingId = selectedBillingId ?? 0;
    //save/update billing address
    billingAddressData.id = billingId;
    billingAddressData.clientId = userModel?.clientId ?? null;
    billingAddressData.typeId = Number(ClientAddressTypeEnum.Billing);
    billingAddressData.isPrimary = true;
    await ClientApi.addUpdateClientAddress(billingAddressData)
      .then((res) => {
        if (res.data.success) {
          billingId = Number(res.data.affectedEntityIdentifier);
        } else {
          billingId = 0;
        }
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
    let shippingId = selectedShippingId ?? 0;
    //save/update shipping address
    shippingAddressData.id = shippingId;
    shippingAddressData.clientId = userModel?.clientId ?? null;
    shippingAddressData.typeId = Number(ClientAddressTypeEnum.Shipping);
    shippingAddressData.isPrimary = true;
    await ClientApi.addUpdateClientAddress(shippingAddressData)
      .then((res) => {
        if (res.data.success) {
          shippingId = Number(res.data.affectedEntityIdentifier);
        } else {
          shippingId = 0;
        }
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
    orderData.billingAddressId = billingId;
    orderData.shippingAddressId = shippingId;
    //update order
    await OrderApi.addUpdateOrder(orderData)
      .then((res) => {
        if (res.data.success) {
          navigate(`/orders/review`);
        }
      })
      .catch((err) => {
        setIsLoading(false);
      });

    setButtonDisabled(false);
  };

  return (
    <>
      <div className="w-full mt-4">
        <div className="container mx-auto p-2">
          <div className="mb-2 flex justify-between">
            <h1 className="text-gray-900 font-bold text-4xl">
              Order Information:
            </h1>
            {orderData && (
              <div className="flex gap-3">
                <div>
                  <Button
                    type="submit"
                    form="checkoutForm"
                    // onClick={() => handleAddItemClick(equipmentData)}
                    className="buttonMain"
                    disabled={buttonDisabled}
                  >
                    Review
                  </Button>
                </div>
              </div>
            )}
          </div>
          <div className="relative">
            {loading && <Loader />}
            <form
              id="checkoutForm"
              onSubmit={onSubmit}
              className="h-[calc(100vh-142px)] md:h-[calc(100vh-210px)] overflow-y-auto"
            >
              <div className="text-gray-600">
                <div className="w-full md:w-1/2 mb-2">
                  <fieldset className="mx-1">
                    <legend className="text-black font-bold bg-gray-100 w-full rounded-t-md px-1">
                      Customer Information
                    </legend>
                    <hr className="bg-gray-300 h-[2px]"></hr>
                    {orderData?.client?.accountNumber && (
                      <div className="grid grid-cols-[35%_65%] px-0 text-sm lg:px-5 md:text-md lg:text-lg">
                        <div className="flex">
                          <div className="font-bold content-center">
                            Account Number:
                          </div>
                        </div>
                        <div className="w-full content-center">
                          {orderData.client.accountNumber}
                        </div>
                      </div>
                    )}
                    <div className="grid grid-cols-[35%_65%] px-0 text-sm lg:px-5 md:text-md lg:text-lg">
                      <div className="flex">
                        <div className="font-bold content-center">
                          PO Number:
                        </div>
                      </div>
                      <div className="w-full">
                        <TextInput
                          id="ponumber"
                          name="ponumber"
                          type="text"
                          placeholder="PO Number..."
                          onChange={handleChangeInputContact}
                          value={orderData?.ponumber ?? ""}
                          sizing="md"
                          required
                        />
                      </div>
                    </div>
                    <div className="grid grid-cols-[35%_65%] px-0 text-sm lg:px-5 md:text-md lg:text-lg">
                      <div className="flex">
                        <div className="font-bold content-center">Name:</div>
                      </div>
                      <div className="w-full">
                        <TextInput
                          id="contactName"
                          name="contactName"
                          type="text"
                          placeholder="Customer Name..."
                          onChange={handleChangeInputContact}
                          value={orderData?.contactName ?? ""}
                          sizing="md"
                          required
                        />
                      </div>
                    </div>
                    <div className="grid grid-cols-[35%_65%] px-0 text-sm lg:px-5 md:text-md lg:text-lg">
                      <div className="flex">
                        <div className="font-bold content-center">Phone:</div>
                      </div>
                      <div className="w-full">
                        <TextInput
                          id="contactPhone"
                          name="contactPhone"
                          type="text"
                          placeholder="Customer Phone..."
                          onChange={handleChangeInputContact}
                          value={orderData?.contactPhone ?? ""}
                          sizing="md"
                          required
                        />
                      </div>
                    </div>
                    <div className="grid grid-cols-[35%_65%] px-0 text-sm lg:px-5 md:text-md lg:text-lg">
                      <div className="flex">
                        <div className="font-bold content-center">Email:</div>
                      </div>
                      <div className="w-full">
                        <TextInput
                          id="contactEmail"
                          name="contactEmail"
                          type="text"
                          placeholder="Customer Email..."
                          onChange={handleChangeInputContact}
                          value={orderData?.contactEmail ?? ""}
                          sizing="md"
                          required
                        />
                      </div>
                    </div>
                  </fieldset>
                </div>
                <div className="flex flex-col md:flex-none md:grid md:grid-cols-[50%_50%] text-xl">
                  <div>
                    <fieldset className="mx-1">
                      <legend className="text-black font-bold bg-gray-100 w-full rounded-t-md px-1">
                        Billing Information
                      </legend>
                      <hr className="bg-gray-300 h-[2px]"></hr>
                      <div className="grid grid-cols-[35%_65%] px-0 text-sm lg:px-5 md:text-md lg:text-lg mb-5 border-b-2">
                        <div className="flex">
                          <div className="font-bold content-center">
                            Saved Addresses:
                          </div>
                        </div>
                        <div className="w-full">
                          <Select
                            id="selectedBillingId"
                            name="selectedBillingId"
                            onChange={handleChangeBilling}
                            value={selectedBillingId ?? ""}
                            sizing="md"
                          >
                            <option value="">-Select-</option>
                            {(addressData ?? [])
                              // ?.filter(
                              //   (x) =>
                              //     x.typeId === ClientAddressTypeEnum.Billing
                              // )
                              .map((addr) => (
                                <option key={addr.id} value={addr.id}>
                                  {addr.address1} {addr.city}
                                  {", "}
                                  {addr.state?.name} {addr.zip}
                                </option>
                              ))}
                          </Select>
                        </div>
                      </div>
                      <div className="grid grid-cols-[35%_65%] px-0 text-sm lg:px-5 md:text-md lg:text-lg">
                        <div className="flex">
                          <div className="font-bold content-center">
                            Billing Address:
                          </div>
                        </div>
                        <div className="w-full">
                          <TextInput
                            id="address1"
                            name="address1"
                            type="text"
                            placeholder="Billing Address..."
                            onChange={handleChangeInputBilling}
                            value={billingAddressData?.address1 ?? ""}
                            sizing="md"
                            required
                          />
                        </div>
                      </div>
                      <div className="grid grid-cols-[35%_65%] px-0 text-sm lg:px-5 md:text-md lg:text-lg">
                        <div className="flex">
                          <div className="font-bold content-center">
                            Billing City:
                          </div>
                        </div>
                        <div className="w-full">
                          <TextInput
                            id="city"
                            name="city"
                            type="text"
                            placeholder="Billing City..."
                            onChange={handleChangeInputBilling}
                            value={billingAddressData?.city ?? ""}
                            sizing="md"
                            required
                          />
                        </div>
                      </div>
                      <div className="grid grid-cols-[35%_65%] px-0 text-sm lg:px-5 md:text-md lg:text-lg">
                        <div className="flex">
                          <div className="font-bold content-center">
                            Billing State:
                          </div>
                        </div>
                        <div className="w-full">
                          <Select
                            id="stateId"
                            name="stateId"
                            onChange={handleChangeSelectBilling}
                            value={billingAddressData?.stateId ?? ""}
                            sizing="md"
                            required
                          >
                            <option value="">-Select-</option>
                            {states.map((state) => (
                              <option key={state.id} value={state.id}>
                                {state.name}
                              </option>
                            ))}
                          </Select>
                        </div>
                      </div>
                      <div className="grid grid-cols-[35%_65%] px-0 text-sm lg:px-5 md:text-md lg:text-lg">
                        <div className="flex">
                          <div className="font-bold content-center">
                            Billing Zip:
                          </div>
                        </div>
                        <div className="w-full">
                          <TextInput
                            id="zip"
                            name="zip"
                            type="text"
                            placeholder="Billing Zip..."
                            onChange={handleChangeInputBilling}
                            value={billingAddressData?.zip ?? ""}
                            sizing="md"
                            required
                          />
                        </div>
                      </div>
                    </fieldset>
                  </div>
                  <div>
                    <fieldset className="mx-1">
                      <legend className="text-black font-bold bg-gray-100 w-full rounded-t-md px-1">
                        Shipping Information
                      </legend>
                      <hr className="bg-gray-300 h-[2px]"></hr>
                      <div className="grid grid-cols-[35%_65%] px-0 text-sm lg:px-5 md:text-md lg:text-lg mb-5 border-b-2">
                        <div className="flex">
                          <div className="font-bold content-center">
                            Saved Addresses:
                          </div>
                        </div>
                        <div className="w-full">
                          <Select
                            id="selectedShippingId"
                            name="selectedShippingId"
                            onChange={handleChangeShipping}
                            value={selectedShippingId ?? ""}
                            sizing="md"
                          >
                            <option value="">-Select-</option>
                            {(addressData ?? [])
                              // ?.filter(
                              //   (x) =>
                              //     x.typeId === ClientAddressTypeEnum.Shipping
                              // )
                              .map((addr) => (
                                <option key={addr.id} value={addr.id}>
                                  {addr.address1} {addr.city}
                                  {", "}
                                  {addr.state?.name} {addr.zip}
                                </option>
                              ))}
                          </Select>
                        </div>
                      </div>
                      <div className="grid grid-cols-[35%_65%] px-0 text-sm lg:px-5 md:text-md lg:text-lg">
                        <div className="flex">
                          <div className="font-bold content-center">
                            Shipping Address:
                          </div>
                        </div>
                        <div className="w-full">
                          <TextInput
                            id="address1"
                            name="address1"
                            type="text"
                            placeholder="Shipping Address..."
                            onChange={handleChangeInputShipping}
                            value={shippingAddressData.address1 ?? ""}
                            sizing="md"
                            required
                          />
                        </div>
                      </div>
                      <div className="grid grid-cols-[35%_65%] px-0 text-sm lg:px-5 md:text-md lg:text-lg">
                        <div className="flex">
                          <div className="font-bold content-center">
                            Shipping City:
                          </div>
                        </div>
                        <div className="w-full">
                          <TextInput
                            id="city"
                            name="city"
                            type="text"
                            placeholder="Shipping City..."
                            onChange={handleChangeInputShipping}
                            value={shippingAddressData.city ?? ""}
                            sizing="md"
                            required
                          />
                        </div>
                      </div>
                      <div className="grid grid-cols-[35%_65%] px-0 text-sm lg:px-5 md:text-md lg:text-lg">
                        <div className="flex">
                          <div className="font-bold content-center">
                            Shipping State:
                          </div>
                        </div>
                        <div className="w-full">
                          <Select
                            id="stateId"
                            name="stateId"
                            onChange={handleChangeSelectShipping}
                            value={shippingAddressData?.stateId ?? ""}
                            sizing="md"
                            required
                          >
                            <option value="">-Select-</option>
                            {states.map((state) => (
                              <option key={state.id} value={state.id}>
                                {state.name}
                              </option>
                            ))}
                          </Select>
                        </div>
                      </div>
                      <div className="grid grid-cols-[35%_65%] px-0 text-sm lg:px-5 md:text-md lg:text-lg">
                        <div className="flex">
                          <div className="font-bold content-center">
                            Shipping Zip:
                          </div>
                        </div>
                        <div className="w-full">
                          <TextInput
                            id="zip"
                            name="zip"
                            type="text"
                            placeholder="Shipping Zip..."
                            onChange={handleChangeInputShipping}
                            value={shippingAddressData.zip ?? ""}
                            sizing="md"
                            required
                          />
                        </div>
                      </div>
                      <div className="grid grid-cols-[35%_65%] px-0 text-sm lg:px-5 md:text-md lg:text-lg mb-5">
                        <div className="flex">
                          <div className="font-bold content-center">
                            Shipping Method:
                          </div>
                        </div>
                        <div className="w-full">
                          <Select
                            id="shippingMethodId"
                            name="shippingMethodId"
                            onChange={handleChangeSelectContact}
                            value={orderData.shippingMethodId ?? ""}
                            sizing="md"
                          >
                            {customOptions
                              ?.filter(
                                (x) =>
                                  x.typeId === CustomOptionsEnum.ShippingMethod
                              )
                              .sort((a, b) =>
                                (a.name ?? "").localeCompare(b.name ?? "")
                              )
                              .map((option) => (
                                <option key={option.id} value={option.id}>
                                  {option.name}
                                </option>
                              ))}
                          </Select>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
